module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chapter"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "#/OEBPS/acknow.htm"
    }
  }, [_vm._v("Acknowledgments")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "#/OEBPS/source.htm"
    }
  }, [_vm._v("Sources")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "#/OEBPS/intro.htm"
    }
  }, [_vm._v("Introduction: Stalin’s Absolute Control, Misconceptions, and Disastrous Decisions")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "#/OEBPS/abbr.htm"
    }
  }, [_vm._v("Abbreviations and Acronyms"), _c('br')]), _c('br'), _c('br')]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "#/OEBPS/ch01.htm"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_c('b', [_vm._v("CHAPTER 1")])]), _vm._v(" Stalin versus Hitler: Background")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "#/OEBPS/ch02.htm"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_c('b', [_vm._v("CHAPTER 2")])]), _vm._v(" The Outspoken General: Ivan Iosifovich Proskurov")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "#/OEBPS/ch03.htm"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_c('b', [_vm._v("CHAPTER 3")])]), _vm._v(" Proskurov Sets Stalin Straight")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "#/OEBPS/ch04.htm"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_c('b', [_vm._v("CHAPTER 4")])]), _vm._v(" Soviet Borders Move Westward")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "#/OEBPS/ch05.htm"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_c('b', [_vm._v("CHAPTER 5")])]), _vm._v(" The Finns Fight: Proskurov Made a Scapegoat")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "#/OEBPS/ch06.htm"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_c('b', [_vm._v("CHAPTER 6")])]), _vm._v(" Soviet Military Intelligence Residencies in Western Europe")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "#/OEBPS/ch07.htm"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_c('b', [_vm._v("CHAPTER 7")])]), _vm._v(" Soviet Military Intelligence Residencies in Eastern Europe")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "#/OEBPS/ch08.htm"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_c('b', [_vm._v("CHAPTER 8")])]), _vm._v(" Who Were You, Dr. Sorge? Stalin Never Heard of You.")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "#/OEBPS/ch09.htm"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_c('b', [_vm._v("CHAPTER 9")])]), _vm._v(" NKVD Foreign Intelligence")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "#/OEBPS/ch10.htm"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_c('b', [_vm._v("CHAPTER 10")])]), _vm._v(" Fitin’s Recruited Spies")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "#/OEBPS/ch11.htm"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_c('b', [_vm._v("CHAPTER 11")])]), _vm._v(" Listening to the Enemy")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "#/OEBPS/ch12.htm"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_c('b', [_vm._v("CHAPTER 12")])]), _vm._v(" Working on the Railroad")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "#/OEBPS/ch13.htm"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_c('b', [_vm._v("CHAPTER 13")])]), _vm._v(" The Border Troops Knew")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "#/OEBPS/ch14.htm"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_c('b', [_vm._v("CHAPTER 14")])]), _vm._v(" Proskurov Is Fired")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "#/OEBPS/ch15.htm"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_c('b', [_vm._v("CHAPTER 15")])]), _vm._v(" Golikov and Operation Sea Lion")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "#/OEBPS/ch16.htm"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_c('b', [_vm._v("CHAPTER 16")])]), _vm._v(" “We Do Not Fire on German Aircraft in Peacetime”")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "#/OEBPS/ch17.htm"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_c('b', [_vm._v("CHAPTER 17")])]), _vm._v(" German Deception: Why Did Stalin Believe It?")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "#/OEBPS/ch18.htm"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_c('b', [_vm._v("CHAPTER 18")])]), _vm._v(" Secret Letters")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "#/OEBPS/ch19.htm"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_c('b', [_vm._v("CHAPTER 19")])]), _vm._v(" The Purges Revived")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "#/OEBPS/ch20.htm"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_c('b', [_vm._v("CHAPTER 20")])]), _vm._v(" On the Eve")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "#/OEBPS/ch21.htm"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_c('b', [_vm._v("CHAPTER 21")])]), _vm._v(" A Summer of Torture")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "#/OEBPS/ch22.htm"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_c('b', [_vm._v("CHAPTER 22")])]), _vm._v(" The Final Reckoning"), _c('br')]), _c('br')]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "#/OEBPS/conclusion.htm"
    }
  }, [_vm._v("Conclusion: Will the Future Be a Repeat of the Past?")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "#/OEBPS/app1.htm"
    }
  }, [_vm._v("Appendix 1: Organization and Functions of Soviet Military Intelligence")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "#/OEBPS/app2.htm"
    }
  }, [_vm._v("Appendix 2: Hitler’s Letters to Stalin")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "#/OEBPS/app3.htm"
    }
  }, [_vm._v("Appendix 3: Those Executed without Trial on October 28, 1941")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "#/OEBPS/app4.htm"
    }
  }, [_vm._v("Appendix 4: Chronology of Agent Reporting")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "#/OEBPS/glossary.htm"
    }
  }, [_vm._v("Glossary of Spies and Their Masters")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "#/OEBPS/note.htm"
    }
  }, [_vm._v("Notes")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "#/OEBPS/index.htm"
    }
  }, [_vm._v("Index")]), _c('br'), _c('br')])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d5344fa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/content.vue
// module id = 72
// module chunks = 0